<!-- 退货卡片消息 -->
<template>
  <div class="ReturnGoodsCard">
    <!-- {{ content }} -->
    <div class="header">{{ content.postsaleTitle }}</div>
    <div class="body">
      <!-- 提示文案 -->
      <div class="tips">{{ content.postsaleText }}</div>
      <!-- 复制的内容 -->
      <div class="copy-content" v-show="showCopy">
        <!-- <div class="title">如需退回药品，请按如下地址填写：</div> -->
        <div class="title">
          如需退回商品，请使用
          <span class="title-tips">【顺丰快递】</span>
          或
          <span class="title-tips">【京东快递】</span>
          并按如下地址填写
        </div>
        <div class="content">
          <div class="item">
            <div class="left">收件人: {{ content.returnReceiver }}</div>
            <!-- <div class="copy-btn" @click="onCopy">复制</div> -->
          </div>
          <div class="item">手机号：{{ content.returnPhone }}</div>
          <div class="item">地址：{{ content.returnAddress }}</div>
        </div>
      </div>
      <!-- 订单号 -->
      <div class="order">
        <div class="order-item">
          <div class="label">订单号:</div>
          <!-- <div class="text">{{ content.parentOrderSn }}</div> -->
          <div class="text">{{ content.orderSn }}</div>
        </div>
        <div class="order-item">
          <div class="label">售后单号:</div>
          <div class="text">{{ content.postsaleSn }}</div>
        </div>
      </div>
    </div>
    <div class="footer">
      <a-button type="primary" block @click="handleClick" class="btn-item">查看详情</a-button>
    </div>
  </div>
</template>

<script setup>
import { handleCopy } from '@/utils'
import { onMounted, defineProps, computed, defineEmits } from 'vue'
const props = defineProps({
  msg: {
    type: Object,
    default: () => {}
    // required: true
  },
  msgBody: {
    type: Object
    // required: true
  }
})
const handleClick = () => {
  emit('handleClick')
}
const onCopy = () => {
  const text = `${content.value.returnReceiver} ${content.value.returnPhone} ${content.value.returnAddress}`
  handleCopy(text)
}
const init = () => {}
onMounted(() => {
  init()
})
const emit = defineEmits()
const content = computed(() => {
  console.log(`output->`, props.msg)
  return props.msg || {}
})
const showCopy = computed(() => {
  // return ['0', '1', '4', '5'].includes(content.value.postsaleType)
  const { returnReceiver, returnPhone, returnAddress } = content.value
  const hasContent = returnReceiver && returnPhone && returnAddress
  // 售后类型 0:待收货未退款,1:已收货待退款,2:已结束,3:已取消,4:待收货已退款
  const show = ['0', '4'].includes(content.value.postsaleStatus)
  if (hasContent && show) {
    return true
  } else {
    return false
  }
})
</script>

<style scoped lang="scss">
.ReturnGoodsCard {
  .header {
    font-size: 16px;
    color: #1a1a1a;
    font-weight: bold;
    padding: 12px;
    border-bottom: 1px solid #fafafa;
    text-align: left;
  }

  .body {
    font-size: 14px;
    color: #3b3b3b;
    padding: 12px;
    text-align: left;
    .tips {
      margin-bottom: 12px;
      color: #3b3b3b;
      font-size: 16px;
      font-weight: 500;
    }
    .copy-content {
      border-radius: 8px;
      background: #f5f7f9;
      font-size: 12px;
      .title {
        padding: 8px 12px;
        color: #959aa2;
        border-bottom: 1px solid #efefef;
        .title-tips {
          color: #3f64ff;
        }
      }
      .content {
        padding: 8px 12px;
        color: #3b3b3b;
        .item {
          margin-bottom: 3px;
          display: flex;
          justify-content: space-between;
          &:last-child {
            margin: 0;
          }
          .copy-btn {
            color: #4c6ee0;
            font-size: 12px;
            width: 24px;
            flex-shrink: 0;
            cursor: pointer;
          }
        }
      }
    }
    .order {
      .order-item {
        display: flex;
        color: #959aa2;
        justify-content: space-between;
        margin-top: 8px;
        .label {
          // width: 60px;
          flex-shrink: 0;
        }
        .text {
          word-break: break-all;
        }
      }
    }
  }
  .footer {
    padding: 0 8px 8px;
  }
}
</style>
